import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../../ParticipantsStore';
import UserGroupMembershipsStore from '../../Store';
import { Ready } from '../../Store/Types';
import { T } from '../../../../../../../../Translations';
import CheckedParticipantsList from './CheckedParticipantsList';
import SelectUserGroup from './SelectUserGroup';
import SubmitButton from './SubmitButton';

interface Props {
  participantsStore: ParticipantsStore;
  userGroupMembershipsStore: UserGroupMembershipsStore;
  state: Ready;
}

const Content: React.FC<Props> = ({ participantsStore, userGroupMembershipsStore, state }) => {
  return (
    <>
      <h3 className="mb-3 text-xl font-semibold">
        <T kind="Add Participants to Group" />
      </h3>
      <SelectUserGroup template={state.template} />
      <CheckedParticipantsList store={participantsStore} />
      <SubmitButton store={userGroupMembershipsStore} template={state.template} />
    </>
  );
};

export default observer(Content);
